import Inlines from '../../../components/vehicle/inline_connections'
import InlineConnectionStore from '../../../components/vehicle/inline_connections/context/context'

const InlinesConnections = () => {
  return (
    <InlineConnectionStore>
      <Inlines />
    </InlineConnectionStore>
  )
}

export default InlinesConnections
